<template>
  <v-container fluid>
    <v-data-iterator
      :items="movies"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header>
        <div class="error" v-if="error">
          {{error}}
        </div>
        <v-toolbar>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Sök"
          ></v-text-field>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer></v-spacer>
            <v-select
              v-model="sortBy"
              flat
              solo-inverted
              hide-details
              :items="keys"
              prepend-inner-icon="mdi-magnify"
              label="Sortera"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle
              v-model="sortDesc"
              mandatory
            >
              <v-btn
                large
                depressed
                :value="false"
              >
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn
                large
                depressed
                :value="true"
              >
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row dense>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card>
              <v-row dense>
                <v-col cols="1">
                <v-img align="end" :width="150" :src="item.moviePoster" />
                </v-col>
                <v-col cols="11">
                  <v-card-title>#{{ item.id }} - {{ item.title }}</v-card-title>
                  <v-card-subtitle>Betyg: {{ item.avgRating }}</v-card-subtitle>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="6">
                  {{ item.plot }} <br/>
                  <span class="grey--text text--lighten-2 caption mr-2">
                  {{ item.year }}, {{ item.runtime }}, Imdb-betyg: {{ item.imdbRating }} <br/>
                  Filmklubb: {{ item.viewDate }} valdes av {{ item.chosenBy }}
                  </span>
                    </v-col>
                <v-col cols="1">
                  Erik:<br/>
                  Johan:<br/>
                  Kerstin:<br/>
                  Lisa:<br/>
                </v-col>
                <v-col cols="1">
                  {{ item.eRating }}<br/>
                  {{ item.jRating }}<br/>
                  {{ item.kRating }}<br/>
                  {{ item.lRating }}<br/>
                </v-col>
                <v-col cols="4">
                  {{ item.eComment }} <br/>
                  {{ item.jComment }} <br/>
                  {{ item.kComment }} <br/>
                  {{ item.lComment }} <br/>
                </v-col>
                  </v-row>
                </v-card-text>
                    <v-btn @click="edit(item)" v-if="$store.state.isUserLoggedIn">Ändra</v-btn>
                    <!-- <v-btn @click="remove(item.id)" v-if="$store.state.isUserLoggedIn">Ta bort</v-btn> -->
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <span class="grey--text">Filmer per sida</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                text
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span
            class="mr-4
            grey--text"
          >
            Sida {{ page }} av {{ numberOfPages }}
          </span>
          <v-btn
            fab
            dark
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            class="ml-1"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>

    </v-data-iterator>
  </v-container>
</template>

<script>
import MoviesService from '@/services/movies_service'
export default {
  data () {
    return {
      itemsPerPageArray: [10, 20, 50, 100],
      itemsPerPage: 10,
      page: 1,
      search: '',
      filter: {},
      sortDesc: true,
      sortBy: 'id',
      keys: [
        { text: 'Datumordning', value: 'id' },
        { text: 'Titel', value: 'title' },
        { text: 'År', value: 'year' },
        { text: 'Längd', value: 'runtime' },
        { text: 'Snittbetyg', value: 'avgRating' },
        { text: 'Eriks betyg', value: 'eRating' },
        { text: 'Johans betyg', value: 'jRating' },
        { text: 'Kerstins betyg', value: 'kRating' },
        { text: 'Lisas betyg', value: 'lRating' },
        { text: 'Imdb-betyg', value: 'imdbRating' }
      ],
      movies: [],
      error: null
    }
  },
  async mounted () {
    this.movies = (await MoviesService.index()).data
  },
  computed: {
    numberOfPages () {
      return Math.ceil(this.movies.length / this.itemsPerPage)
    },
    filteredKeys () {
      return this.keys.filter(key => key !== `Name`)
    }
  },
  methods: {
    async remove (id) {
      this.error = null
      try {
        await MoviesService.remove({'id': id})
        this.movies = (await MoviesService.index()).data
      } catch (err) {
        this.error = err
      }
    },
    async edit (item) {
      this.$router.push({
        name: 'movies-edit',
        params: item
      })
    },
    nextPage () {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    formerPage () {
      if (this.page - 1 >= 1) this.page -= 1
    },
    updateItemsPerPage (number) {
      this.itemsPerPage = number
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Movies.vue